// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.stain_result_enum */
var StainResultEnum;
(function (StainResultEnum) {
    StainResultEnum["CLEAN"] = "CLEAN";
    StainResultEnum["SUSPECT"] = "SUSPECT";
    StainResultEnum["CONTAMINATED"] = "CONTAMINATED";
})(StainResultEnum || (StainResultEnum = {}));
;
export default StainResultEnum;
/** Zod schema for stain_result_enum */
export const stainResultEnum = z.nativeEnum(StainResultEnum);
//# sourceMappingURL=StainResultEnum.js.map